import axiosHttpClient from "./axiosHttpClient";

export async function getUser(userId: number){
	return axiosHttpClient.get('read/users/'+userId.toString());
}